import { useMemo } from 'react'
import { AVATAR_INFO } from '../../constants/avatars'
import { useLanguage } from '@context/LanguageContext'
import Carousel from '@components/interface/Carousel'
import { getAvatarName } from '../../logic/getAvatarName'
import { getAvatarSrc } from '../../logic/getAvatarSrc'
import styles from './AvatarSelector.module.css'

export default function AvatarSelector ({
  onSelect,
  currentAvatar,
  labelledById,
  isOpen,
  onOpen,
  onClose
}) {
  const { t } = useLanguage()

  const buttonLabel = useMemo(() => {
    if (currentAvatar) {
      const avatarName = getAvatarName(currentAvatar, t)
      return t.shared.access.avatar.selector.selected.replace('{avatar}', avatarName)
    }
    return t.shared.access.avatar.selector.select
  }, [currentAvatar, t])

  const imageSrc = getAvatarSrc(currentAvatar)

  const getInitialIndex = (avatarFilename) => {
    if (!avatarFilename) {
      return 0 // Start from Fiorito for new players
    }
    const index = AVATAR_INFO.findIndex(avatar => avatar.filename === avatarFilename)
    return index !== -1 ? index : 0 // Fallback to 0 if not found
  }

  const getDisplayName = (item) => {
    const { translationKey, name } = item
    if (!translationKey) return name
    return t.shared?.avatarNames?.[translationKey] ?? name
  }

  const handleSelect = (selectedItem) => {
    onSelect(selectedItem.filename)
    onClose()
  }

  return (
    <>
      <button
        type='button'
        className={styles.button}
        onClick={onOpen}
        aria-labelledby={labelledById}
        title={buttonLabel}
      >
        <img
          src={imageSrc}
          alt={buttonLabel}
          className={styles.image}
        />
      </button>

      {isOpen && (
        <Carousel
          items={AVATAR_INFO}
          currentIndex={getInitialIndex(currentAvatar)}
          onSelect={handleSelect}
          onClose={onClose}
          variant='modal'
          imageType='avatar'
          showName
          ariaLabel={t.shared.access.avatar.selector.dialog}
          instructions={t.shared.access.avatar.selector.instructions}
          getDisplayName={getDisplayName}
        />
      )}
    </>
  )
}
